import { cn } from '@bem-react/classname';

export const cnTimeline = cn('Timeline');
export const timelineCn = cnTimeline();
export const timelineInnerCn = cnTimeline('Inner');
